import * as React from "react";
import { useState } from "react";
import store from "../../../store/store";

import AudioVolume from "./AudioSettings/AudioVolume";
import Wallet from "./Wallet";

import menu from "../../../assets/img/common/menu.svg";
import close from "../../../assets/img/common/close.svg";
import SideMenu from "./SideMenu";

const Header: React.FC = () => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);

  const closeModal = (): void => {
    setIsSideMenuOpen(false);
  };

  return (
    <header>
      <button
        type="button"
        onClick={() => {
          setIsSideMenuOpen((prevState) => !prevState);
          setIsLanguageMenuOpen(false);
        }}
        className="burger_button"
      >
        {!isSideMenuOpen && (
          <img className="burger_icon menu" src={menu} alt="" />
        )}
        {isSideMenuOpen && (
          <img className="burger_icon close" src={close} alt="" />
        )}
      </button>
      <SideMenu
        isSideMenuOpen={isSideMenuOpen}
        isLanguageMenuOpen={isLanguageMenuOpen}
        setIsLanguageMenuOpen={setIsLanguageMenuOpen}
        closeModal={closeModal}
      />
      {!store.getState().config.iosOrMacOsPlatform && <AudioVolume />}
      <Wallet />
    </header>
  );
};
export default Header;
